module.exports = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, options;
  buffer += "\n    <ul class=\"thumb-list\">\n        ";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.generateThumbList || depth0.generateThumbList),stack1 ? stack1.call(depth0, depth0.pages, options) : helperMissing.call(depth0, "generateThumbList", depth0.pages, options)))
    + "\n    </ul>\n";
  return buffer;
  }

function program3(depth0,data) {
  
  
  return "\n    <div class=\"loading black-overlay\"></div>\n";
  }

  stack1 = helpers['if'].call(depth0, depth0.pages, {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  return buffer;
  });